/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_UpdatedInputs */

const en_admin_posts_updated = /** @type {(inputs: Admin_Posts_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post updated`)
};

/**
* | output |
* | --- |
* | "Post updated" |
*
* @param {Admin_Posts_UpdatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_updated = /** @type {((inputs?: Admin_Posts_UpdatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_UpdatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_updated(inputs)
});
export { admin_posts_updated as "admin.posts.updated" }